<template>
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M9 11.6521C9 11.7443 8.96488 11.8328 8.90237 11.898C8.83986 11.9633 8.75507 11.9999 8.66667 11.9999C8.57826 11.9999 8.49348 11.9633 8.43096 11.898C8.36845 11.8328 8.33333 11.7443 8.33333 11.6521C8.33333 11.5598 8.36845 11.4714 8.43096 11.4061C8.49348 11.3409 8.57826 11.3043 8.66667 11.3043C8.75507 11.3043 8.83986 11.3409 8.90237 11.4061C8.96488 11.4714 9 11.5598 9 11.6521ZM9 11.6521H8.66667M12.3333 11.6521C12.3333 11.7443 12.2982 11.8328 12.2357 11.898C12.1732 11.9633 12.0884 11.9999 12 11.9999C11.9116 11.9999 11.8268 11.9633 11.7643 11.898C11.7018 11.8328 11.6667 11.7443 11.6667 11.6521C11.6667 11.5598 11.7018 11.4714 11.7643 11.4061C11.8268 11.3409 11.9116 11.3043 12 11.3043C12.0884 11.3043 12.1732 11.3409 12.2357 11.4061C12.2982 11.4714 12.3333 11.5598 12.3333 11.6521ZM12.3333 11.6521H12M15.6667 11.6521C15.6667 11.7443 15.6315 11.8328 15.569 11.898C15.5065 11.9633 15.4217 11.9999 15.3333 11.9999C15.2449 11.9999 15.1601 11.9633 15.0976 11.898C15.0351 11.8328 15 11.7443 15 11.6521C15 11.5598 15.0351 11.4714 15.0976 11.4061C15.1601 11.3409 15.2449 11.3043 15.3333 11.3043C15.4217 11.3043 15.5065 11.3409 15.569 11.4061C15.6315 11.4714 15.6667 11.5598 15.6667 11.6521ZM15.6667 11.6521H15.3333M20 11.6521C20 15.8779 16.4178 19.3042 12 19.3042C11.2331 19.3052 10.4694 19.2001 9.72889 18.9916C8.68512 19.7576 7.41184 20.1057 6.14222 19.972C6.00106 19.9578 5.8605 19.9377 5.72089 19.9117C6.15899 19.373 6.4582 18.7265 6.59022 18.0335C6.67022 17.6096 6.472 17.1978 6.17511 16.8963C4.82667 15.5273 4 13.6825 4 11.6521C4 7.42628 7.58222 4 12 4C16.4178 4 20 7.42628 20 11.6521Z"
      stroke="#696F79"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'GreyCommentIcon24'
};
</script>

<style scoped>

</style>
